import { useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/solid';

const AccordionItem = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);
  const createMarkup = (htmlContent) => ({ __html: htmlContent });

  return (
    <div className="accordion-item bg-white p-4 rounded-lg shadow-md mb-4">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="accordion-header flex justify-between items-center p-2 w-full text-left text-lg font-semibold text-gray-700 hover:text-gray-900 focus:outline-none focus-visible:ring focus-visible:ring-opacity-75"
      >
        {title}
        <ChevronDownIcon
          className={`h-6 w-6 transition-transform ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </button>
      {isOpen && (
        <div
          className="accordion-content text-gray-600 mt-2"
          dangerouslySetInnerHTML={createMarkup(content)}
        />
      )}
    </div>
  );
};

const UserOnboardingGuide = () => {
  const accordionData = [
    {
      title: 'Getting Started with ChowBuddy',
      content: `
      <p>On Telegram, search for <strong>ChowBuddyBot</strong> and press 'Start'.</p>
    `
    },
    {
      title: 'Main Menu',
      content: `
      <p>You'll see a welcome message and options:</p>
      <ul>
        <li>Get a recipe with my ingredients.</li>
        <li>Inspire me with a random quick meal.</li>
        <li>Quick meal inspired by a country.</li>
      </ul>
    `
    },
    {
      title: 'Choosing an Option',
      content: `
      <p>Select an option to start your culinary adventure.</p>
    `
    },
    {
      title: 'Feature Walkthrough',
      content: `
      <ul>
        <li><strong>Get a Recipe:</strong> Tell us your ingredients for a custom recipe.</li>
        <li><strong>Random Quick Meal:</strong> Let us suggest a meal ready in 30 minutes.</li>
        <li><strong>Inspired by a Country:</strong> Name a country for a regional dish.</li>
      </ul>
    `
    },
    {
      title: 'Follow-Up Actions',
      content: `
      <ul>
        <li><strong>Another Quick Meal:</strong> Not satisfied? Request another suggestion.</li>
        <li><strong>Return to Main Menu:</strong> Explore other options anytime.</li>
      </ul>
    `
    }
    // {
    //   title: 'Tips for a Great Experience',
    //   content: `
    //   <ul>
    //     <li><strong>Be Specific:</strong> Detailed inputs help us provide better suggestions.</li>
    //     <li><strong>Feedback:</strong> Enjoyed a meal? Your feedback helps us improve.</li>
    //     <li><strong>Questions:</strong> Need help? Just ask, and we'll guide you.</li>
    //   </ul>
    // `
    // }
  ];

  return (
    <section className="onboarding-guide bg-gray-100">
      <div className="container mx-auto px-4 py-12">
        <h2 className="text-4xl font-bold text-center mb-8 text-gray-800">
          Welcome to ChowBuddy
        </h2>
        <div className="accordion-grid grid gap-4">
          {accordionData.map((item, index) => (
            <AccordionItem
              key={index}
              title={item.title}
              content={item.content}
            />
          ))}
        </div>
        <div className="text-center mt-12">
          <a
            href="https://t.me/ChowBuddyBot"
            className="bg-purple-500 text-white px-8 py-3 rounded-full font-semibold hover:bg-purple-400 transition duration-300"
            target="_blank"
            rel="noopener noreferrer"
          >
            Chat Now
          </a>
        </div>
      </div>
    </section>
  );
};

export default UserOnboardingGuide;
